// --
import React from 'react';
const ReactDOM = require('react-dom');
import {connect} from 'react-redux';
import {Row, Col, Modal, Button, Badge, Input} from 'reactstrap';
import AbstractReactComponent from './../AbstractReactComponent';
import FormBody from './../form/FormBody';
import FormActions from './../form/FormActions';
import Form from './../form/Form';
import FieldGrid from './../form/FieldGrid';
import McField from './../field/McField';
import * as Fields from './../field';
import {startSubmit, stopSubmit, Field, reduxForm, getFormValues} from 'redux-form'
import AdresaApi from "./../api/gen/adresy/AdresaApi";
import {toastr} from 'react-redux-toastr'
import i18n from './../i18n/i18n'
import {Icon} from './../icon'
import StoreUtils from './../utils/StoreUtils'
import {SubmissionError} from 'redux-form'
import ValidationErrors from "./ValidationErrors";

/**
 * Porovnání dvou řetězců pomocí ignore case s přihlédnutím na locale.
 * @param x řetězec 1
 * @param y řetězec 2
 * @return {boolean} true, pokud jsou řetězce stejné
 */
const localeEqualsIgnoreEquals = (x, y) => {
    if (x === y) {
        return true;
    }
    if (!x && y || x && !y) {
        return false;
    }

    return x.toLocaleLowerCase().localeCompare(y.toLocaleLowerCase()) === 0;
};

/**
 * Test, zda zadaný stát je česká republika - implementace převzata z cz.marbes.commons.formatter.adresa.AdresaTools.
 * @param nazevStat název stát, nemusí být zadaný
 * @return {boolean} true, pokud je zadaný stát ČR
 */
const isCR = (nazevStat) => {
    if (!nazevStat) {   // pokud není uveden, bere se implcitně ČR
        return true;
    }

    return false
        || localeEqualsIgnoreEquals("Česká republika", nazevStat)
        || localeEqualsIgnoreEquals("Česko", nazevStat)
        || localeEqualsIgnoreEquals("ČR", nazevStat)
        || localeEqualsIgnoreEquals("CZE", nazevStat)
        || localeEqualsIgnoreEquals("CZ", nazevStat);
};

/** Validace formuláře adresy. */
const validate = (formData) => {
    var errors = {};
    const errorMessages = [];

    if (isCR(formData.stat)) {    // adresa v ČR
        if (!formData.obec) {
            errorMessages.push(i18n("adresa.form.validation.cr.obec.required"));
        }

        if (!formData.cisloDomovni && (!formData.ulice || !formData.cisloOrientacni)) {
            errorMessages.push(i18n("adresa.form.validation.cr.common.required"));
        }

    } else {    // adresa mimo ČR
        if (!formData.obec) {
            errorMessages.push(i18n("adresa.form.validation.noCr.obec.required"));
        }
    }

    if (errorMessages.length > 0) {
        errors["_error"] = errorMessages.join(" ");
    }

    return errors;
};

/**
 * Komponenta pro vlastní formulář, může být buď součástí těla dialogu nebo jako samostatný div kontejner.
 * Určení se provádí automaticky na základě kontextu.
 */
class AdresaForm extends AbstractReactComponent {
    static formName = 'adresaForm';

    static PropTypes = {
        fieldLabelPrefix: React.PropTypes.string,
        preview: React.PropTypes.bool, // pokud je true, je formulář zobrazen pouze pro náhled
        overeniDisabled: React.PropTypes.bool,
    };

    static defaultProps = {
        defaultFieldLabelPrefix: "adresa.form.title.", // neměnit, jedná se o výchozí prefix pro formulář, pro který jsou texty definované v shared
        fieldLabelPrefix: "adresa.form.title.",
        overeniDisabled: false,
    };

    constructor(props) {
        super(props);

        this.state = {
            showOvereniError: false,
            verifying: false,
        }
    }

    componentWillReceiveProps(nextProps) {
        const {change, formData: newFormData} = nextProps;
        const {formData : prevFormData} = this.props;
        const {showOvereniError} = this.state;

        if (!prevFormData && newFormData || prevFormData && !newFormData) { // nic neděláme, změna stavu celých dat
            // ...nic
        } else {
            if (nextProps.formData !== this.props.formData && !StoreUtils.objectEquals(prevFormData, newFormData)) {   // něco se na formuláři změnilo
                // Při jakékoli změně nechceme již zobrazovat chybu posledního ověření
                if (showOvereniError) {
                    this.setState({
                        showOvereniError: false
                    })
                }

                // Změna dat na formuláři
                if (prevFormData && newFormData && !prevFormData.registrId && newFormData.registrId) {  // adresa se ověřila
                    // Zde neděláme nic
                } else {    // u jiné změny resetujeme ověření
                    if (newFormData) {
                        // newFormData.overenaAdresa !== null && this.dispatch(change("overenaAdresa", false));
                        newFormData.registrId !== null && this.dispatch(change("registrId", null));
                        // newFormData.idObecRegistr !== null && this.dispatch(change("idObecRegistr", null));
                    }
                }
            }
        }
    }

    renderForm = (disabled) => {
        const {error, defaultFieldLabelPrefix, fieldLabelPrefix, formData, overeniDisabled} = this.props;
        const {showOvereniError, verifying} = this.state;
        const overenaAdresa = (formData && formData.registrId != null);

        const commons = {
            label: true,
            disabled: disabled,
        };

        let overeniAdresy;
        if (!overeniDisabled) {
            if (overenaAdresa) {
                overeniAdresy = <Badge color="success" title={i18n("adresa.form.title.overenaAdresa.overeno.tooltip")}>{i18n("adresa.form.title.overenaAdresa.overeno")}</Badge>
            } else {
                let valid = Object.keys(validate(formData || {}, this.props)).length === 0;
                overeniAdresy = (
                    <div>
                        <div>
                            <Badge color="danger" title={i18n("adresa.form.title.overenaAdresa.neovereno.tooltip")}>{i18n("adresa.form.title.overenaAdresa.neovereno")}</Badge>
                        <Button className="pull-right" disabled={!valid || !formData || disabled} onClick={this.handleVerify} title={i18n("adresa.form.action.ztotozniAdresu.tooltip")}>
                            {verifying && <Icon icon="refresh" animation="spin"/>}
                            {i18n("adresa.form.action.ztotozniAdresu")}
                        </Button>
                    </div>
                    {error && <div>
                        <br/>
                        <ValidationErrors error={error} />
                    </div>}
                </div>)
            }
        }

        return (
            <FormBody fieldLabelPrefix={[fieldLabelPrefix, defaultFieldLabelPrefix]}>
                <Row>
                    <Col>
                        <McField name={"ulice"} field={Fields.String} maxLength={48} {...commons} />
                        <McField name={"cisloOrientacni"} field={Fields.Number} int {...commons} />
                        <McField name={"cisloOrientacniPismeno"} field={Fields.String} maxLength={1} {...commons} title={true}/>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <McField name={"castObce"} field={Fields.String} maxLength={48} {...commons} />
                        <McField name={"cisloDomovni"} field={Fields.Number} int {...commons} />
                        <McField name={"cisloDomovniZnak"} field={Fields.Select} {...commons} title={true}>
                            <option></option>
                            <option value="E">E</option>
                        </McField>

                        <McField name={"mestCast"} field={Fields.String} maxLength={48} {...commons} />
                    </Col>
                </Row>

                <McField row name={"obec"} field={Fields.String} maxLength={48} {...commons} />

                <Row>
                    <Col>
                        <McField name={"psc"} field={Fields.String} maxLength={10} {...commons} />
                        <McField name={"posta"} field={Fields.String} maxLength={48} {...commons} />
                    </Col>
                </Row>

                <McField row name={"okres"} field={Fields.String} maxLength={32} {...commons} />

                <McField row name={"kraj"} field={Fields.String} maxLength={32} {...commons} />

                <McField row name={"stat"} field={Fields.String} maxLength={240} {...commons} />

                {!overeniDisabled && (
                    <FieldGrid {...commons} label="overenaAdresa" error={showOvereniError ? i18n("adresa.form.action.ztotozniAdresu.title.neztotozneno") : null}>
                        {overeniAdresy}
                    </FieldGrid>
                )}
            </FormBody>
        )
    };

    handleVerify = () => {
        const {initialize, formData} = this.props;

        if (formData) {
            this.setState({
                verifying: true
            });
            startSubmit();
            AdresaApi.ztotozniAdresu(formData)
                .then(data => {
                    if (data) {
                        this.setState({
                            showOvereniError: false
                        })
                        initialize(data);
                    } else {
                        this.setState({
                            showOvereniError: true
                        })
                    }
                    stopSubmit();

                    this.setState({
                        verifying: false
                    });
                })
                .catch(err => {
                    stopSubmit();

                    this.setState({
                        verifying: false
                    });

                    err && console.error(err);
                    throw err;
                });
        }
    }

    customHandleSubmit = (e) => {
        const {formData, onSubmit, handleSubmit, change} = this.props;
        e.preventDefault();
        e.stopPropagation();

        if (formData) {
            startSubmit();
            AdresaApi.aktualizujPopisAdresy(formData)
                .then(data => {
                    this.dispatch(change("popis", data.popis));
                    handleSubmit(onSubmit)()
                        .catch(() => {
                            stopSubmit();
                        });
                })
                .catch(() => {
                    stopSubmit();
                });
        }
    };

    render() {
        const {preview, onClose, submitting} = this.props;
        const {verifying} = this.state;
        const disabled = submitting || verifying || preview;

        return (
            <Form horizontal onSubmit={this.customHandleSubmit}>
                {this.renderForm(disabled)}
                {!preview && <FormActions onClose={onClose} disabled={disabled} onSubmit={this.customHandleSubmit} okButton cancelButton/>}
                {preview && <FormActions onClose={onClose} closeButton/>}
            </Form>
        )
    }
}

const reduxAdresaForm = reduxForm({
    form: AdresaForm.formName,
    validate
})(AdresaForm);

function mapStateToProps(state, props) {
    const formName = props.formName || AdresaForm.formName;
    return {
        formData: getFormValues(formName)(state)
    };
}
export default connect(mapStateToProps)(reduxAdresaForm)
